import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

import ImgA from "../../assets/images/feeder.png";
import DarkWaitlistForm from "../../component/DarkWaitlistForm";
import FeederSpecs from "../../component/FeederSpecs";

class Section extends Component {
  constructor() {
    super();
    const experiments = [
      {
        waitlist_version: 1,
        waitlist_name: "catfeeder",
        header:
          "I got fed up with low quality, plastic, and ugly automatic cat feeders.",
        CTA: "I want to join the pre-sales waitlist",
        img: ImgA,
        color: "red",
      },
    ];

    // Check if an experiment is already stored in localStorage
    // const persistedExperiment = localStorage.getItem("selectedExperiment");
    const selectedExperiment = experiments[0];

    // // Save the selected experiment to localStorage if it wasn't already saved
    // if (!persistedExperiment) {
    //   localStorage.setItem(
    //     "selectedExperiment",
    //     JSON.stringify(selectedExperiment)
    //   );
    // }

    this.state = {
      isOpen: false,
      selectedExperiment,
    };

    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  render() {
    const { header, subheader, img } = this.state.selectedExperiment;

    return (
      <React.Fragment>
        <section className="bg-home black-bg" id="home">
          <div className="home-center">
            <div className="home-desc-center">
              <Container>
                <Row className="align-items-center">
                  <Col lg={6}>
                    <div className="home-img">
                      <div className="hero">
                        <img
                          src={img}
                          className="img-fluid hero-photo-gmw"
                          alt=""
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="home-content">
                      <div className="home-img"></div>
                      <p className="biz-name biz-name-dk-theme mt-4 mb-0">
                        Automatic Cat Feeder Cabinet
                      </p>
                      <h1 className="home-title-dk-theme mt-4">{header}</h1>
                      <p className="text-muted mt-4 f-20">
                        {" "}
                        I built an automatic feeder cabinet that fits my home's
                        aesthetics while withstanding my cat's brutal daily
                        assaults. The number I create depends on demand, so if
                        you're interested in pre-ordering, please join the
                        waitlist!
                      </p>
                      <DarkWaitlistForm
                        selectedExperiment={this.state.selectedExperiment}
                      />
                      <p className="text-muted mt-4 f-10 text-center">
                        We'll never share your information with anyone.
                      </p>
                    </div>
                  </Col>
                </Row>
                <Row className="align-items-center">
                  <Col lg={12}>
                    <FeederSpecs />
                    <DarkWaitlistForm
                      selectedExperiment={this.state.selectedExperiment}
                    />
                    <p className="text-muted mt-4 f-10 text-center">
                      We'll never share your information with anyone.
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
